import React, { useState, useEffect } from 'react';
import { useDataProvider, Button, useNotify } from 'react-admin';
import { getChainId } from '../../lib'
import { Wrapper, Centrelized, Title, Loader, Row } from '../../components'
import MomentUtils from '@date-io/moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import "moment/locale/pt-br";
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles, withStyles, Paper } from '@material-ui/core';
import { buildStatementRows, productLabelOf, TransactionType } from '../../utils/statement';

const useStyles = makeStyles({
    table: {
        marginTop: 20
    },
    reprintButton: {
        height: 36,
        textTransform: 'none',
    },
});

const StyledTableCell = withStyles(() => ({
    head: {
        fontSize: 16,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const ClientStatement = ({ userId, printCallback }) => {
    const classes = useStyles();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [loading, setLoading] = useState(false);
    const [dateFrom, setDateFrom] = useState(moment().subtract(30, 'd').startOf('days'))
    const [dateTo, setDateTo] = useState(moment().endOf('days'))
    const [tableData, setTableData] = useState(null)
    const [balance, setBalance] = useState(null)

    const ReprintButton = ({ coupon, printCallback }) => (
        <Button
            className={classes.reprintButton}
            onClick={() => printCallback(coupon)}
            label="Reimprimir"
            variant="contained"
        />
    )

    const Statement = ({ transactions }) => {
        if (!transactions || transactions.length === 0) {
            return (
                <Typography align="center">
                    Nenhum lançamento encontrado
                </Typography>
            );
        }
        return (
            <TableContainer className={classes.table} component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="center">Data</StyledTableCell>
                            <StyledTableCell align="center">Pontos</StyledTableCell>
                            <StyledTableCell align="center">Descrição</StyledTableCell>
                            <StyledTableCell align="center">Produto</StyledTableCell>
                            <StyledTableCell align="center">Ponto de Troca</StyledTableCell>
                            <StyledTableCell align="center">Cupom</StyledTableCell>
                            <StyledTableCell align="center"></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(transactions.map(row => {
                            return (
                                <TableRow key={row.id}>
                                    <TableCell align="center">{moment(row.createdAt).format('DD/MM/YYYY HH:mm')}</TableCell>
                                    <TableCell align="center">{row.type === TransactionType.expiration || row.type === TransactionType.redemption ? -row.value : row.value}</TableCell>
                                    <TableCell align="center">{row.typeString}</TableCell>
                                    <TableCell align="center">{productLabelOf(row)}</TableCell>
                                    <TableCell align="center">{row.isCoupon && row.place?.name ? row.place.name : null}</TableCell>
                                    <TableCell align="center">{row.barcode}</TableCell>
                                    <TableCell align="center">{
                                        row.isCoupon ?
                                            row.redeemed ? "Cupom Utilizado"
                                                : row.refunded ? "Cupom estornado"
                                                    :
                                                    <ReprintButton coupon={row} printCallback={printCallback} />
                                            : null}
                                    </TableCell>
                                </TableRow>);
                        }))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let filter = {
                from: moment.utc(dateFrom),
                to: moment.utc(dateTo),
            }

            try {
                const response = await dataProvider.getList(`chains/${getChainId()}/customers/${userId}/transactions`, { filter });
                const { transactions, currentBalance, customerName } = response.data;

                // Os cupons vêm num request separado: o endpoint de extrato deixou de
                // embutir `transaction.coupons` (join removido por custo no banco).
                // Sem isso o extrato fica sem nome de produto, sem barcode e sem
                // reimpressão.
                //
                // Usa o endpoint POR CLIENTE, não `GET /coupons?filter={transactionIds}`
                // que o admin usa: aquele estreita por `placeId` do JWT, e operador
                // amarrado a um posto deixaria de ver cupom emitido em outro.
                let coupons = [];
                if (transactions && transactions.length > 0) {
                    const couponsResponse = await dataProvider.getList(`chains/${getChainId()}/customers/${userId}/coupons`, { filter: {} });
                    coupons = couponsResponse.data || [];
                }

                setTableData(buildStatementRows(transactions, coupons, customerName));
                setBalance(currentBalance);
            } catch (error) {
                notify('Erro ao listar o extrato', 'warning');
            } finally {
                setLoading(false);
            }
        }
        fetchData()
    }, [dateFrom, dateTo, dataProvider, notify, userId])

    return (
        <Wrapper>
            <Centrelized>
                <Row width='100%'>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br'>
                        <DatePicker
                            label="De"
                            value={dateFrom}
                            onChange={date => setDateFrom(date)}
                            format={'DD/MM/YYYY'}
                        />
                        <DatePicker
                            label="Até"
                            value={dateTo}
                            onChange={date => setDateTo(date)}
                            format={'DD/MM/YYYY'}
                        />
                    </MuiPickersUtilsProvider>
                </Row>
                <Title marginTop={true}>Saldo atual: {balance && Number(balance).toFixed(2)} pontos</Title>
                <Title marginTop={true}>Histórico</Title>
                {loading ? <Loader /> : tableData ? <Statement transactions={tableData} /> : null}
            </Centrelized>
        </Wrapper>
    );
}

export default ClientStatement;